/**
 * Kenyan shilling.
 */
export var KES = {
  code: 'KES',
  base: 10,
  exponent: 2
};